import { render, staticRenderFns } from "./ClockDoughnut.vue?vue&type=template&id=4cb499ca&scoped=true&"
import script from "./ClockDoughnut.vue?vue&type=script&lang=js&"
export * from "./ClockDoughnut.vue?vue&type=script&lang=js&"
import style0 from "./ClockDoughnut.vue?vue&type=style&index=0&id=4cb499ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb499ca",
  null
  
)

export default component.exports